/**
 * Finds the array value corresponding to the date
* // if before any date: take next available rate
* // if after last date: take last available rate
* @param {Array<{date: string, anyProperty: any}>} rates should be sorted by date
* @param {string} date "YYYY-MM-DD"
* @returns
*/
export function findRateOfDate (rates, date) {
  if (!rates) return null
  // Default to the first rate
  let latestRate = rates?.[0]

  // Then use the latest rate before the date
  for (const rate of rates) {
    if (rate.date <= date) {
      latestRate = rate
    }
  }
  return latestRate
}
